/**
 * Tour step definitions for the Trades page.
 * @param {Function} t - i18n translation function
 * @returns {Array} react-joyride steps
 */
export function getTradesTourSteps(t) {
  return [
    {
      target: '[data-tour="whale-trades-card"]',
      title: t('onboarding.trades.step1Title'),
      content: t('onboarding.trades.step1Content'),
      placement: 'right',
      disableBeacon: true
    },
    {
      target: '[data-tour="whale-sound-toggle"]',
      title: t('onboarding.trades.step2Title'),
      content: t('onboarding.trades.step2Content'),
      placement: 'bottom',
      disableBeacon: true,
      spotlightClicks: true
    },
    {
      target: '[data-tour="whale-trades-feed"]',
      title: t('onboarding.trades.step3Title'),
      content: t('onboarding.trades.step3Content'),
      placement: 'right',
      disableBeacon: true
    },
    {
      target: '[data-tour="liquidations-card"]',
      title: t('onboarding.trades.step4Title'),
      content: t('onboarding.trades.step4Content'),
      placement: 'left',
      disableBeacon: true
    },
    {
      target: '[data-tour="filters"]',
      title: t('onboarding.trades.step5Title'),
      content: t('onboarding.trades.step5Content'),
      placement: 'bottom',
      disableBeacon: true
    },
    {
      target: '#live-price',
      title: t('onboarding.trades.step6Title'),
      content: t('onboarding.trades.step6Content'),
      placement: 'bottom',
      disableBeacon: true
    },
    {
      target: '[data-tour="right-column"]',
      title: t('onboarding.trades.step7Title'),
      content: t('onboarding.trades.step7Content'),
      placement: 'left',
      disableBeacon: true
    },
    {
      target: '[data-tour="header-help-button"]',
      title: t('onboarding.trades.step8Title'),
      content: t('onboarding.trades.step8Content'),
      placement: 'bottom',
      disableBeacon: true
    }
  ];
}
